import type { AlpineComponent } from 'alpinejs';

export const slider = ({
	initialActiveIndex = 0
}: {
	initialActiveIndex?: string;
} = {}): AlpineComponent => ({
	activeIndex: initialActiveIndex,
	change: {},
	progress: 0,
	slidesPerPage: 1,
	isScrollable: false,

	init() {
		this.$watch('change', () => {
			this.progress = this.__getProgress();
			this.slidesPerPage = this.__getSlidesPerPage();
			this.isScrollable = !!this.__getOverscrollWidth();
		});
	},

	scrollBy(left: 1 | -1) {
		this.$refs.track.scrollBy({ left, behavior: 'smooth' });
	},

	get atStart() {
		return this.progress === 0;
	},

	get atEnd() {
		return 1 - this.progress < 0.01;
	},

	get pagesAmount(): number {
		return Math.ceil(this.$refs.track.children.length / this.slidesPerPage);
	},

	get currentPageIndex(): number {
		// as the determination of `atEnd` isn't precise, it's safer to treat this case separately
		if (this.atEnd) {
			return this.pagesAmount - 1;
		}

		return Math.floor((this.pagesAmount - 1) * this.progress);
	},

	get dots() {
		return Array.from({ length: this.pagesAmount }, (_, i) => i);
	},

	goto(index: string) {
		this.activeIndex = index;
		this.change = {};
	},

	onSliderGoto({
		eventDetail,
		index,
		el
	}: {
		eventDetail: string;
		index: string;
		el: HTMLElement;
	}) {
		if (eventDetail === index) {
			this.goto(index);
			el.scrollIntoView({
				behavior: 'smooth',
				inline: 'nearest',
				block: 'nearest'
			});
		}
	},

	__getProgress(): number {
		const scrollLeft = this.$refs.track.scrollLeft;
		return scrollLeft / this.__getOverscrollWidth() || 0;
	},

	__getOverscrollWidth(): number {
		return this.$refs.track.scrollWidth - this.$refs.track.clientWidth;
	},

	__getSlidesPerPage(): number {
		const firstChild = this.$refs.track.children?.[0];

		if (!firstChild) {
			return 1;
		}

		return Math.floor(this.$refs.track.clientWidth / firstChild.clientWidth);
	}
});
